"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../index");

var _index2 = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _navlinks_styles = _interopRequireDefault(require("./navlinks_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// utils
// styles
// Returns the component specified by item.element defaulting to <Link /> with the supplied arguments


var newCTA = function newCTA(item) {
  var ComponentType = item.element === 'button' ? _index.Button : _index.Link;
  return _react.default.createElement(ComponentType, {
    name: item.name,
    type: item.type,
    action: item.action,
    text: item.text,
    icon: item.icon,
    iconStyle: item.iconStyle,
    activeSection: item.activeSection,
    allowMultiClick: !!item.allowMultiClick,
    isActive: item.isActive,
    processing: item.processing,
    disabled: item.disabled,
    badge: item.badge
  });
};
/* ========== ~~~~~~~~~~ EXPORT : NAV LINKS ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_navlinks_styles.default)(function (props) {
  return _react.default.createElement("nav", {
    className: "nav ".concat((0, _index2.generateClasses)(props), " ").concat(props.classes.nav)
  }, props.items.map(function (item) {
    return item.permitted === false ? null : _react.default.createElement("div", {
      className: "navitem ".concat((0, _index2.generateClasses)(item), " selected-").concat(!!item.selected)
    }, newCTA(item));
  }));
});

exports.default = _default;